// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"e9c56e7c","486":"6a00685c","618":"de0b7c2b"}[chunkId] + ".chunk.js";
};